import { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import "./DrawerComponent.css";
import { useTranslation } from "react-i18next";
import {
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemButton,
  ListItemIcon,
  CssBaseline,
} from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import { useHistory, useLocation } from "react-router-dom";
import { isDesktop, isMobile } from "react-device-detect";


const PREFIX = 'DrawerComponent';

const classes = {
  root: `${PREFIX}-root`,
  HamburgerIconButton: `${PREFIX}-HamburgerIconButton`,
  title: `${PREFIX}-title`,
  toolBar: `${PREFIX}-toolBar`,
  openDrawer: `${PREFIX}-openDrawer`,
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled("div")(({ theme }) => ({
  flexGrow: 0,
  height: "24px",
  maxWidth: "24px",
  position: "relative",
  top: "18px",
  // fill: "",
  // Default (Desktop >= md): Hide the entire DrawerComponent container
  display: "none",

  marginLeft: "0",
  marginRight: "10px",
  // "& .MuiListItem-root": {
  //   backgroundColor: "#fff",
  //   opacity: "0.25 !important",
  // },
  // "& .Mui-selected": {
  //   backgroundColor: "#fff",
  //   opacity: "0.25 !important",
  // },
  // Custom media query for max-width: 768px
  "@media only screen and (max-width: 768px)": {
    display: "block", // Use 'block' to make it visible
  },
}));


const HamburgerIconButton = styled(IconButton)(({ theme }) => ({
  marginRight: theme.spacing(0),
}));

const Title = styled("div")(({ theme }) => ({
  flexGrow: 1,
}));

const StyledToolbar  = styled(Toolbar)(({ theme }) => ({
  minHeight: "24px",
  height: "24px",
  paddingLeft: "1px",
  paddingRight: "1px",
}));

const OpenDrawer = styled(Drawer)(({ theme }) => ({
  width: "50% !important",
  maxWidth: "220px",
  minWidth: "185px",
  top: "79px !important",
}));


const logOutURL = process.env.REACT_APP_LOGOUT_URL;
const TabsList = [
  {
    name: "Home",
    path: "/home",
  },
  { name: "Focus area ecosystem", path: "/focus-area" },
  { name: "Propose a focus area", path: "/proposals" },
  { name: "Logout", path: logOutURL },
];

const DrawerComponent = (props) => {
  const [openDrawer, setOpenDrawer] = useState(false);

  const { t } = useTranslation()
  const history = useHistory();
  const location = useLocation();
  const [value, setValue] = useState(history.location.pathname);
  useEffect(() => {
    setValue(history.location.pathname);
  }, [location]);
  const handleChange = (event, item) => {
    setValue(item.path);
    history.push(item.path);
    setOpenDrawer(false);
    if(item.name === "Logout"){
      window.location.href=logOutURL;
    }
  };

  let isAdmin = false;
  const users = process.env.REACT_APP_ADMIN_PERMISSIONS.split(" ");
  if (users && users.length > 0) {
    isAdmin = true;
  }
  if (isAdmin && !TabsList[3] && !isMobile && isDesktop) {
    TabsList.push({ name: "Admin", path: "/admin" });
  }
  // if (isMobile && !TabsList[3]) {
  //   TabsList.push({ name: "Log out", path: logOutURL });
  // }

  return (
    <>
      <CssBaseline />
      <OpenDrawer
        anchor="right"
        onClose={() => setOpenDrawer(false)}
        open={openDrawer}
        
      >
        <List>
          {TabsList.map((item, key) => {
            return (
              <ListItemButton 
                
                selected={item.path === value}
              key= {item.id || item.path} 
              onClick={(e) => handleChange(e, item)}
>
                <ListItemIcon
                  value={value}
                >
                  <ListItemText label={item.name} key={key} value={item.path}>
                    {t(item.name)}
                  </ListItemText>
                </ListItemIcon>
              </ListItemButton>
            );
          })}
        </List>
      </OpenDrawer>
      <Root>
        <AppBar position="static">
          <StyledToolbar>
            <HamburgerIconButton
              onClick={() => setOpenDrawer(true)}
              edge="start"
              color="inherit"
              aria-label="menu"
              size="large"
            >
              <MenuIcon />
            </HamburgerIconButton>
          </StyledToolbar>
        </AppBar>
      </Root>
    </>
  );
};
export default DrawerComponent;
